import { render, staticRenderFns } from "./merchantManagement.vue?vue&type=template&id=f8b1aea2&scoped=true&"
import script from "./merchantManagement.vue?vue&type=script&lang=js&"
export * from "./merchantManagement.vue?vue&type=script&lang=js&"
import style0 from "./merchantManagement.vue?vue&type=style&index=0&id=f8b1aea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b1aea2",
  null
  
)

export default component.exports